<template>
  <g>
    <path
      d="M18 12.0002C17.45 12.0002 17 12.4502 17 13.0002V18.2202C17 18.7702 16.55 19.2202 16 19.2202H6C5.45 19.2202 5 18.7702 5 18.2202V8.00024C5 7.45024 5.45 7.00024 6 7.00024H11C11.55 7.00024 12 6.55024 12 6.00024C12 5.45024 11.55 5.00024 11 5.00024H5C3.9 5.00024 3 5.90024 3 7.00024V19.0002C3 20.1002 3.9 21.0002 5 21.0002H17C18.1 21.0002 19 20.1002 19 19.0002V13.0002C19 12.4502 18.55 12.0002 18 12.0002Z"
    />
    <path
      d="M21.02 5.00024H19V2.98024C19 2.44024 18.56 2.00024 18.02 2.00024H17.99C17.44 2.00024 17 2.44024 17 2.98024V5.00024H14.99C14.45 5.00024 14.01 5.44024 14 5.98024C14 5.99024 14 6.00024 14 6.01024C14 6.56024 14.44 7.00024 14.99 7.00024H17V9.01024C17 9.55024 17.44 10.0002 17.99 9.99024C18 9.99024 18.01 9.99024 18.02 9.99024C18.56 9.99024 19 9.55024 19 9.01024V7.00024H21.02C21.56 7.00024 22 6.56024 22 6.02024V5.98024C22 5.44024 21.56 5.00024 21.02 5.00024Z"
    />
    <path
      d="M14 9.00024H8C7.45 9.00024 7 9.45024 7 10.0002C7 10.5502 7.45 11.0002 8 11.0002H14C14.55 11.0002 15 10.5502 15 10.0002C15 9.45024 14.55 9.00024 14 9.00024Z"
    />
    <path
      d="M14 12.0002H8C7.45 12.0002 7 12.4502 7 13.0002C7 13.5502 7.45 14.0002 8 14.0002H14C14.55 14.0002 15 13.5502 15 13.0002C15 12.4502 14.55 12.0002 14 12.0002Z"
    />
    <path
      d="M14 15.0002H8C7.45 15.0002 7 15.4502 7 16.0002C7 16.5502 7.45 17.0002 8 17.0002H14C14.55 17.0002 15 16.5502 15 16.0002C15 15.4502 14.55 15.0002 14 15.0002Z"
    />
  </g>
</template>
